import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "./updateActypes.css";

const isValidAcType = (acType) => acType !== "";

const UpdateActypes = () => {
  const [acType, setAcType] = useState([]);

  const params = useParams();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();

    const acTypeIsValid = isValidAcType(acType);

    if (acTypeIsValid) {
      try {
        const url = `https://api.generalhome.sa/api/ACTypes/${params.updateId}`;
        await axios.put(url, {
          ACTypeId: params.updateId,
          Name: acType,
        });
        toast.success("تم تعديل نوع المكيف بنجاح", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/dashboard/addAcTypes");
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const getAcTypesDetails = async () => {
    try {
      const response = await axios.get(
        `https://api.generalhome.sa/api/ACTypes/${params.updateId}`
      );
      setAcType(response.data.Name);
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getAcTypesDetails();
  }, []);

  return (
    <section className="updateAc">
      <div className="updateAc-container container">
        <div className="row">
          <div className="col-lg-12-md-12">
            <form onSubmit={submit} className="acAddTypesForm">
              <div className="inputBox">
                <label htmlFor="acType">نوع المكيف:</label>
                <input
                  type="text"
                  placeholder="نوع المكيف"
                  value={acType}
                  onChange={(e) => setAcType(e.target.value)}
                />
              </div>
              <button>تعديل</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdateActypes;
